import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: JSON.parse(sessionStorage.getItem('user')) || null,
        token: sessionStorage.getItem('token') || null, // If added later
        branch: {
            name: window.APP_IDENTITY?.BRANCH_NAME || import.meta.env.VITE_BRANCH_NAME || 'Main Branch',
            cd: window.APP_IDENTITY?.BRANCH_CD || import.meta.env.VITE_BRANCH_CD || 'MN'
        }
    }),
    getters: {
        isLoggedIn: (state) => !!state.user,
        userLevel: (state) => state.user?.user_level || 0,
        fullname: (state) => state.user?.ufullname || '',
        isAdmin: (state) => state.user?.user_level == 1
    },
    actions: {
        setUser(userData) {
            this.user = userData;
            sessionStorage.setItem('user', JSON.stringify(userData));
            sessionStorage.setItem('userid', userData.user_id);
            sessionStorage.setItem('ufullname', userData.ufullname);
            sessionStorage.setItem('branch_cd', userData.branch_cd);
            sessionStorage.setItem('user_level', userData.user_level);
        },
        logout() {
            this.user = null;
            sessionStorage.clear();
        }
    }
});
